<template>
  <div class="blog-page" id="main-wrapper">
    <NavbarDark />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">Privacy Details</h2>
            <span class="ipn-subtitle"
              >See Our Latest privacy policies below</span
            >
          </div>
        </div>
      </div>
    </div>
    <section class="gray-simple">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="blog-details single-post-item format-standard">
              <div class="post-details">
                <div class="post-featured-img">
                  <img
                    class="img-fluid"
                    :src="data && data.image ? data.image : blog"
                    alt=""
                  />
                </div>

                <!-- <h2 class="post-title">
                  {{
                    data && data.title
                      ? data.title
                      : "Lorem ipsum dolor sit amet, cons pisicing elit, sed do."
                  }}
                </h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt utlabore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum. Sed ut perspiciatis unde omnis
                  iste natus error sit voluptatem accusantium doloremque
                  laudantium, totam rem aperiam, eaque ipsa quae ab illo
                  inventore veritatis et quasi architecto beatae vitae dicta
                  sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                  aspernatur aut odit aut fugit, sed quia consequuntur magni
                  dolores eos qui ratione voluptatem sequi nesciunt. Neque porro
                  quisquam est, qui dolorem. <br /><br />
                  Duis aute irure dolor in reprehenderit in voluptate velit esse
                  cillum dolore eu fugiat nulla pariatur. Excepteur sint
                  occaecat cupidatat non proident, sunt in culpa qui officia
                  deserunt mollit anim id est laborum. Sed ut perspiciatis unde
                  omnis iste natus error sit voluptatem accusantium doloremque
                  laudantium, totam rem aperiam, eaque ipsa quae ab illo
                  inventore veritatis et quasi architecto beatae vitae dicta
                  sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                  aspernatur aut odit aut fugit, sed quia consequuntur magni
                  dolores eos qui ratione voluptatem.
                </p> -->
                <!-- <blockquote>
                  <span class="icon"><i class="fas fa-quote-left"></i></span>
                  <p class="text">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmodtem ut labore et dolore magna aliqua. Ut enim
                    ad minim veniam, quis nostrud ullamco laboris nisi ut
                    aliquip ex ea commodo onsequat.
                  </p>
                  <h5 class="name">- Rosalina Pong</h5>
                </blockquote> -->
                <!-- <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum. Sed ut perspiciatis unde omnis
                  iste natus error sit voluptatem accusantium doloremque
                  laudantium, totam rem aperiam, eaque ipsa quae ab illo
                  inventore veritatis et quasi architecto beatae vitae dicta
                  sunt explicabo. Nemo enimipsam voluptatem quia voluptas sit
                  aspernatur aut odit aut fugit, sed quia consequunturmagni
                  dolores eos qui ratione voluptatem sequi nesciunt. Neque porro
                  quisquam est, quidolorem. <br /><br />Duis aute irure dolor in
                  reprehenderit in voluptate velit esse cillumdolore eu fugiat
                  nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt inculpa qui officia deserunt mollit anim id est
                  laborum. Sed ut perspiciatis unde omnisiste natus error sit
                  voluptatem accusantium doloremque laudantium, totam rem
                  aperiam,eaque ipsa quae ab illo inventore veritatis et quasi
                  architecto beatae vitae dicta suntexplicabo. Nemo enim ipsam
                  voluptatem quia voluptas sit aspernatur aut odit aut fugit,sed
                  quia consequuntur magni dolores eos qui ratione voluptatem.
                </p> -->
                <section class="post-title">
                  <h2>Privacy Policy - 99 Property Management</h2>
                  <p><strong>Effective Date:</strong> 01-Jan-2025</p>
                </section>

                <h3>1. Introduction</h3>
                <p class="text">
                  99 Property Management ("we," "us," or "our") is committed to
                  protecting the privacy of your personal information. This
                  Privacy Policy outlines how we collect, use, disclose, and
                  safeguard your information when you use our services,
                  including our website, mobile applications, and property
                  management services.
                </p>
                <br />

                <h3>2. Information We Collect</h3>
                <ul class="text">
                  <li>
                    <strong>Personal Information:</strong>
                    <ul class="colored-list">
                      <li>Name, address, phone number, email address</li>
                      <li>
                        Date of birth, social security number (or equivalent),
                        and other identification information (when required for
                        legal or contractual purposes)
                      </li>
                      <li>
                        Financial information (e.g., bank account details,
                        payment history)
                      </li>
                      <li>
                        Rental history, credit reports, and background check
                        information
                      </li>
                      <li>Emergency contact information</li>
                      <li>
                        Information provided in applications, leases, and other
                        agreements
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Property Information:</strong>
                    <ul class="colored-list">
                      <li>
                        Property address, details, and maintenance records
                      </li>
                      <li>Photographs and videos of properties</li>
                      <li>
                        Information related to property inspections and
                        assessments
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Website and Application Information:</strong>
                    <ul class="colored-list">
                      <li>IP address, browser type, and operating system</li>
                      <li>Cookies and other tracking technologies</li>
                      <li>
                        Usage data, such as pages visited and time spent on our
                        website or applications
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Communication Information:</strong>
                    <ul class="colored-list">
                      <li>
                        Records of communications with us, including emails,
                        phone calls, and text messages.
                      </li>
                      <li>
                        Information provided in customer support inquiries.
                      </li>
                    </ul>
                  </li>
                </ul>

                <br />

                <h3>3. How We Use Your Information</h3>
                <p>We use your information for the following purposes:</p>
                <ul class="text">
                  <li>
                    <strong>Property Management Services:</strong>
                    <ul class="colored-list">
                      <li>Processing rental applications and leases</li>
                      <li>Collecting rent and managing payments</li>
                      <li>
                        Scheduling and performing property maintenance and
                        repairs
                      </li>
                      <li>Conducting background checks and credit reports</li>
                      <li>Communicating with tenants and property owners</li>
                      <li>Enforcing lease agreements</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Customer Service:</strong>
                    <ul class="colored-list">
                      <li>Responding to inquiries and providing support</li>
                      <li>Resolving disputes and complaints</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Marketing and Communication:</strong>
                    <ul class="colored-list">
                      <li>
                        Sending newsletters, updates, and promotional materials
                        (with your consent)
                      </li>
                      <li>Conducting surveys and market research</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Legal and Compliance:</strong>
                    <ul class="colored-list">
                      <li>Complying with applicable laws and regulations</li>
                      <li>Protecting our rights and property</li>
                      <li>Preventing fraud and other illegal activities</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Website and Application Improvement:</strong>
                    <ul class="colored-list">
                      <li>
                        Analyzing usage data to improve our website and
                        applications
                      </li>
                    </ul>
                  </li>
                </ul>
                <br />

                <h3>4. Disclosure of Your Information</h3>
                <p>We may disclose your information to:</p>
                <ul class="text colored-list">
                  <li>
                    <strong>Property Owners:</strong> We may share information
                    with property owners as necessary to manage their
                    properties.
                  </li>
                  <li>
                    <strong>Service Providers:</strong> We may share information
                    with third-party service providers who assist us with our
                    operations, such as maintenance contractors, credit
                    reporting agencies, and payment processors.
                  </li>
                  <li>
                    <strong>Legal Authorities:</strong> We may disclose
                    information to legal authorities when required by law or to
                    protect our rights.
                  </li>
                  <li>
                    <strong>Business Transfers:</strong> In the event of a
                    merger, acquisition, or sale of assets, your information may
                    be transferred to the acquiring entity.
                  </li>
                  <li>
                    <strong>With your Consent:</strong> We may share your
                    information with third parties with your consent.
                  </li>
                </ul>
                <br />

                <h3>5. Data Security</h3>
                <p class="text">
                  We implement reasonable security measures to protect your
                  information from unauthorized access, disclosure, and use.
                  However, no method of transmission over the internet or
                  electronic storage is completely secure.
                </p>
                <br />

                <h3>6. Data Retention</h3>
                <p class="text">
                  We retain your information for as long as necessary to fulfill
                  the purposes outlined in this Privacy Policy, unless a longer
                  retention period is required or permitted by law.
                </p>
                <br />

                <h3>7. Your Rights</h3>
                <p class="text">
                  You may have the following rights regarding your personal
                  information:
                </p>
                <ul class="text colored-list">
                  <li>
                    <strong>Access:</strong> You may request access to the
                    personal information we hold about you.
                  </li>
                  <li>
                    <strong>Correction:</strong> You may request that we correct
                    any inaccurate or incomplete information.
                  </li>
                  <li>
                    <strong>Deletion:</strong> You may request that we delete
                    your personal information (subject to legal and contractual
                    obligations).
                  </li>
                  <li>
                    <strong>Opt-Out:</strong> You may opt-out of receiving
                    marketing communications.
                  </li>
                  <li>
                    <strong>Data Portability:</strong> You may request a copy of
                    your personal information in a portable format.
                  </li>
                </ul>
                <p>
                  To exercise these rights, please contact us using the contact
                  information provided below.
                </p>
                <br />

                <h3>8. Children's Privacy</h3>
                <p class="text">
                  Our services are not intended for children under the age of
                  [Age]. We do not knowingly collect personal information from
                  children under this age.
                </p>
                <br />

                <h3>9. Changes to This Privacy Policy</h3>
                <p class="text">
                  We may update this Privacy Policy from time to time. We will
                  notify you of any material changes by posting the updated
                  policy on our website or by other means.
                </p>
                <br />

                <h3>10. Contact Us</h3>
                <p class="text">
                  99 Property Management<br />150 Edmonton Ave #4B, Moncton, NB E1C 3B9<br />+1 5068897999<br />rent@99properties.ca
                </p>
                <br />
              </div>
            </div>
            <div class="blog-details single-post-item format-standard">
              <div class="posts-author">
                <span class="img"
                  ><img class="img-fluid" :src="user1" alt=""
                /></span>
                <SocialDetails/>
                <p class="pa-text">
                  For all your real estate needs in and around Greater Moncton area !!!!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <FooterTop :bg="'theme-bg'" /> -->

    <FooterDark />

    <ScrollToTop />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import blog from "@/assets/img/p-1.jpg";
import user1 from "@/assets/img/99PM_WEBSITE.svg";
// import BlogSidebar from '@/components/blog-sidebar.vue';
import FooterDark from "@/components/footer/footer-dark.vue";
// import FooterTop from "@/components/footer/footer-top.vue";
import NavbarDark from "@/components/navbar/navbar-dark.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";
import { blogData } from "@/data/data";
import SocialDetails from "@/components/social-details.vue";

const route = useRoute();

const data = blogData.find((item) => item.id === parseInt(route.params.id));
</script>

<style scoped>
/* General styling for unordered lists */
ul.text {
  list-style-type: none; /* Default bullet points */
  padding-left: 20px; /* Add indentation */
  margin-bottom: 20px; /* Add spacing below the list */
}

/* Styling for list items */
ul.text li {
  list-style-type: none; /* Remove default bullets */
  position: relative; /* Position for custom icon */
  padding-left: 25px; /* Add space for the icon */
  margin-bottom: 10px; /* Add spacing between list items */
  font-size: 1rem; /* Adjust font size */
  color: #555; /* Set text color */
  line-height: 1.6; /* Improve readability */
}

ul.text li::before {
  content: "\2022"; /* Unicode for a bullet point */
  position: absolute;
  left: 0;
  color: #007bff; /* Custom bullet color */
  font-size: 1.2rem; /* Custom bullet size */
}

/* Styling for nested lists */
ul.colored-list {
  list-style-type: circle; /* Use circle bullets for nested lists */
  padding-left: 20px; /* Add indentation for nested lists */
}

ul.colored-list li {
  margin-bottom: 8px; /* Add spacing between nested list items */
  color: #333; /* Slightly darker color for nested items */
}

/* Add custom icons for list items */
ul.text li::marker {
  color: #007bff; /* Change bullet color to primary blue */
  font-size: 1.2rem; /* Make bullets slightly larger */
}

/* Add hover effect for list items */
ul.text li:hover {
  color: #007bff; /* Change text color on hover */
  cursor: pointer; /* Add pointer cursor on hover */
}
</style>
